import React, { createContext, ReactNode, useContext, useState } from 'react';

interface IContext {
    visible: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalContext = createContext({} as IContext);

export const useModalContext = () => {
    return useContext(ModalContext);
};

export const ModalProvider = ({ children }: { children: ReactNode }) => {
    const [visible, setVisible] = useState(false);

    return (
        <ModalContext.Provider value={{ visible, setVisible }}>{children}</ModalContext.Provider>
    );
};
